import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useReferralXml = (messageControlId) => {
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["referralXml", messageControlId, tenantVal],
    queryFn: async () => {
      if (!messageControlId) return null;

      const axiosInstance = createAxiosInstance();

      try {
        const response = await axiosInstance.get(
          `${tenantVal}/healthlink/messages/${messageControlId}/xml`
        );

        return response?.data || null;
      } catch (error) {
        /*
         * A referral whose message isn't stored answers 404 — since KIN-1495 with an
         * ApiResponse body rather than an empty one, but either way it is the normal
         * answer for "no document yet", not a failure. Treated as no document, so the
         * preview shows its empty state instead of a retrying query.
         */
        if (error?.response?.status === 404) return null;

        throw error;
      }
    },
    enabled: !!messageControlId,
    meta: { errorMessage: "Error fetching referral XML" },
  });
};
